var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9724 0.138923C11.5556 0.0463614 11.1156 0 10.6756 0C7.82719 0 5.32609 1.78321 4.35345 4.40002C1.94511 4.49258 -0.000244141 6.48416 -0.000244141 8.93899C-0.000244141 11.4401 2.0377 13.478 4.53872 13.478L16.8124 13.5011C19.6608 13.5011 21.9998 11.1853 21.9998 8.31376C21.9765 5.3035 19.3827 2.84895 16.3259 3.14959C15.9553 2.59376 15.5152 2.08424 15.029 1.66748C14.4105 1.0404 12.7336 0.38716 11.9724 0.138923ZM1.75947 8.96225C1.75947 7.45707 2.98684 6.20641 4.51531 6.20641C4.60787 6.20641 4.6775 6.22951 4.77006 6.22951L4.88588 6.25261C5.349 6.32207 5.76592 6.02096 5.85851 5.58111C6.39111 3.35786 8.38269 1.80632 10.6754 1.80632C10.8376 1.80632 10.9996 1.82942 11.1618 1.82942C11.7849 1.94528 13.2686 2.4132 14.2184 3.35801C14.5426 3.70532 14.8437 4.09915 15.0521 4.53903C15.2374 4.90959 15.6311 5.09486 16.0478 5.00215C16.3026 4.93269 16.5573 4.90959 16.789 4.90959C18.6647 4.90959 20.1932 6.43806 20.1932 8.31381C20.1932 10.1896 18.6649 11.7181 16.789 11.7181H10.2353L6.46087 11.6947H4.53876C2.98689 11.718 1.75947 10.4674 1.75947 8.96225Z",
    fill: "#24AF22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOn);
export default __webpack_public_path__ + "static/media/cloud-on.5bb34778057e8dd73fbec2a627064043.svg";
export { ForwardRef as ReactComponent };